import React from 'react';
import { ErrorPage } from '@gjensidige/se-error-page';

export const PageNotFound = () => {
    return (
        <main>
            <div className="page-not-found" >
                <ErrorPage
                    headingText='Något gick fel!'
                    descriptionText='Sidan du letar efter finns inte'
                    primaryButtonLabel='Gå tillbaka'
                    primaryBtnOnClick={() => {
                        window.location.href = '/';
                    }}
                />
            </div>
        </main>
    );
};
    